import { css } from 'styled-components';
import { math } from 'polished';
import { SDS_SIZE_BORDER_SMALL } from '@s-group/design-system-tokens/web/tokens/size.es6.js';
import * as spaceTokens from '@s-group/design-system-tokens/web/tokens/space.es6.js';
import { SDS } from '../common/namespace.js';

const lineWidth = SDS_SIZE_BORDER_SMALL;
const borderColor = ({ role, theme }) => role === 'presentation'
    ? theme[SDS].colors.SDS_BRAND_COLOR_BORDER_WEAK_NEUTRAL
    : theme[SDS].colors.SDS_BRAND_COLOR_BORDER_DEFAULT_NEUTRAL;
const borderWidth = ({ orientation }) => orientation === 'vertical' ? `0 ${lineWidth} 0 0` : `0 0 ${lineWidth} 0`;
const spacing = ({ spacing }) => spacing
    ? spaceTokens[`SDS_SPACE_${spacing.toUpperCase()}`]
    : '0';
const nonRetinaBeforeMargin = spacing;
const nonRetinaAfterMargin = (props) => math(`${spacing(props)} - ${lineWidth}`);
const nonRetinaMargin = ({ orientation, spacing }) => orientation === 'vertical'
    ? // top=0 right=after bottom=0 left=before
        `0 ${nonRetinaAfterMargin({ spacing })} 0 ${nonRetinaBeforeMargin({
            spacing,
        })}`
    : // top=before right=0 bottom=after left=0
        `${nonRetinaBeforeMargin({ spacing })} 0 ${nonRetinaAfterMargin({
            spacing,
        })} 0`;
const retinaOrthogonalMargin = (props) => math(`${spacing(props)} - ${lineWidth} / 2`);
const retinaMargin = ({ orientation, spacing }) => orientation === 'vertical'
    ? `0 ${retinaOrthogonalMargin({ spacing })}`
    : `${retinaOrthogonalMargin({ spacing })} 0`;
const DividerStyle = css `
    border-color: ${borderColor};
    border-style: solid;
    border-width: ${borderWidth};
    margin: ${nonRetinaMargin};

    @media (min-resolution: 150dpi) {
        margin: ${retinaMargin};
    }
`;

export { DividerStyle };
//# sourceMappingURL=Divider.styles.js.map
